module.exports = __webpack_public_path__ + "static/assets/409c50625f58b375897423d8ef96ec59.svg";